import React from "react";
import PropTypes from "prop-types";

export default class IconButton extends React.Component {
  
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }
  
  render() {
    const { className, onClick, src } = this.props;
    return (
      <div className={`icon-button ${className}`} onClick={onClick}>
        <img className="icon-button__img" src={src} alt="add" />
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/IconButton.js